<template>
    <Modal
        :title="'Plan İptali'"
        @ok="confirm"
        @cancel="close"
        :cancel-text="'Vazgeç'"
        :ok-text="'Onayla'"
        :show-footer="true"
    >
        Plan iptali gerçekleştikten sonra paket kullanımınız ay başına kadar devam edecektir. İptal etmek istediğinizden
        emin misiniz?
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";

export default {
    name: "CancelPlanModal",
    components: {
        Modal,
    },
    methods: {
        close() {
            this.$emit("reject");
        },
        confirm() {
            this.$emit("confirm");
        },
    },
};
</script>
